<div class="notifications-page">
  <!-- Breadcrumb -->
  <div class="page-breadcrumb">
    <a routerLink="/">Home</a>
    <mat-icon>chevron_right</mat-icon>
    <span class="current">Notifications</span>
  </div>

  <!-- Title Row -->
  <div class="page-title-row">
    <div class="page-title">
      <h1>Notifications</h1>
      <span class="total-badge" *ngIf="notifications.length > 0">{{ notifications.length }}</span>
    </div>
    <div class="page-actions">
      <button mat-stroked-button
              class="btn-mark-read"
              [disabled]="unreadCount === 0"
              (click)="onMarkAllRead()">
        <mat-icon>done_all</mat-icon>
        Mark all as read
      </button>
      <button mat-stroked-button
              class="btn-delete-all"
              [disabled]="notifications.length === 0 || isLoading"
              (click)="onDeleteAll()">
        <mat-icon>delete_outline</mat-icon>
        Delete all
      </button>
    </div>
  </div>

  <!-- Filter Chips -->
  <div class="page-filters">
    <button *ngFor="let f of filterOptions"
            class="filter-chip"
            [class.active]="activeFilter === f.value"
            [attr.aria-pressed]="activeFilter === f.value"
            (click)="setFilter(f.value)">
      {{ f.label }}
      <span class="chip-count">{{ getFilterCount(f.value) }}</span>
    </button>
  </div>

  <!-- Loading Bar -->
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate" class="page-loader"></mat-progress-bar>

  <!-- Notification Cards -->
  <div class="notif-card-list" *ngIf="filteredNotifications.length > 0; else emptyPage">
    <div *ngFor="let note of filteredNotifications; let i = index; trackBy: trackByNotifId"
         class="notif-card"
         [class.unread]="!note.isRead"
         [class.deleting]="deletingIds.has(note.id)"
         [style.cursor]="(note.meetingNoteId || note.rootMeetingNoteId || note.leaveRequestId != null || note.globalRequestId != null || note.type === 'task_list') ? 'pointer' : 'default'"
         (click)="onNotificationClick(note)"
         [@cardAnimation]>

      <div class="notif-card-inner">
        <!-- Avatar -->
        <div class="notif-avatar" [ngClass]="getAvatarConfig(note).cssClass">
          <span class="notif-avatar-initials">{{ note.senderInitials }}</span>
          <span class="notif-avatar-badge" [ngClass]="getAvatarConfig(note).iconClass">
            <mat-icon>{{ getAvatarConfig(note).icon }}</mat-icon>
          </span>
        </div>

        <!-- Content -->
        <div class="notif-content">
          <div class="notif-text" [innerHTML]="highlightMessage(note.message)"></div>
          <div class="notif-meta">
            <span class="notif-time">
              <mat-icon>schedule</mat-icon>
              {{ note.relativeTime }}
            </span>
            <span class="notif-unread-dot" *ngIf="!note.isRead"></span>
            <span class="notif-tag" *ngIf="getStatusTag(note) as tag" [ngClass]="tag.cssClass">
              {{ tag.label }}
            </span>
          </div>
        </div>

        <!-- Actions -->
        <div class="notif-card-actions" (click)="$event.stopPropagation()">
          <button mat-icon-button
                  *ngIf="isAdmin && note.leaveRequestId != null"
                  matTooltip="View request"
                  aria-label="View leave request"
                  (click)="onViewLeave(note)"
                  bcNavLink="/hr/leave/pending" [bcNavLinkQueryParams]="{ requestId: note.leaveRequestId }">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button
                  *ngIf="!note.isRead"
                  matTooltip="Mark as read"
                  aria-label="Mark notification as read"
                  (click)="onMarkAsRead(note, i)">
            <mat-icon>mark_email_read</mat-icon>
          </button>
          <button mat-icon-button
                  matTooltip="Delete"
                  aria-label="Delete notification"
                  class="delete-btn"
                  [disabled]="isLoading"
                  (click)="onDelete(note, i)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty Page State -->
  <ng-template #emptyPage>
    <div class="empty-page-state" *ngIf="!isLoading">
      <mat-icon>notifications_none</mat-icon>
      <h3>No notifications</h3>
      <p>You're all caught up. New notifications will appear here.</p>
    </div>
  </ng-template>
</div>
